var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ALP 40px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "26.2025595%",
    gradientTransform: "translate(0.500000,0.500000),scale(1.000000,0.987500),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo&buttom-svg",
    transform: "translate(-494.000000, -884.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALP-40px",
    transform: "translate(494.000000, 884.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#007AF0",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(7.360000, 7.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0907659,1.73294763 C22.2282509,3.5463721 24.4395611,6.59921618 25.201119,10.0563733 L25.1987307,10.0461553 C25.6677445,12.0992867 24.0443082,14.0997212 21.9363869,14.1564068 L21.8723639,14.1575276 L15.013,14.168 L18.43618,20.1235272 L18.4574647,20.1598214 C19.5373249,22.0426806 18.5745995,24.4059833 16.518449,25.0758942 L16.4551651,25.0958704 L16.4326923,25.1027378 L16.4099963,25.1088259 C12.9173243,26.0457161 9.27042755,25.6479411 6.18923409,23.8670524 C3.05174908,22.0536279 0.84043892,19.0007838 0.0788810141,15.5436267 L0.0812692821,15.5538447 C-0.387744462,13.5007133 1.23569175,11.5002788 3.34361305,11.4435932 L3.4076361,11.4424724 L10.265,11.431 L6.84382005,5.47647278 L6.82253528,5.44017863 C5.74267514,3.55731935 6.70540052,1.19401674 8.76155096,0.524105814 L8.82483488,0.504129611 L8.84730775,0.497262155 L8.87000367,0.491174098 C12.3626757,-0.445716114 16.0095724,-0.0479410738 19.0907659,1.73294763 Z M11.4729678,14.1590635 L11.4521726,14.1592549 L3.42721529,14.1717976 L3.40905821,14.1723018 C3.00261382,14.1887889 2.67205774,14.5897322 2.73544679,14.9283879 L2.73901102,14.9455518 L2.74131889,14.9558395 C3.33902842,17.6691929 5.08195173,20.0754013 7.55243886,21.5033099 C9.88597367,22.8520619 12.6490647,23.1990311 15.3521534,22.5611935 L15.680804,22.4784378 C16.1092317,22.3346023 16.2946884,21.8806655 16.0957123,21.5236267 L16.0854425,21.5058574 L16.0791104,21.4952847 L16.0729702,21.4845992 L12.0681943,14.5153072 L12.0630093,14.5062839 L12.0579623,14.4971825 C11.9523222,14.306677 11.7845198,14.1911971 11.5788474,14.1647832 L11.4729678,14.1590635 Z M9.18428772,4.07637327 L9.19455755,4.09414258 L9.2008896,4.10471532 L9.20702985,4.11540085 L13.2118057,11.0846928 L13.2169907,11.0937161 L13.2220377,11.1028175 C13.3276778,11.293323 13.4954802,11.4088029 13.7011526,11.4352168 L13.8070322,11.4409365 L13.8278274,11.4407451 L21.8527847,11.4282024 L21.8709418,11.4276982 C22.2773862,11.4112111 22.6079423,11.0102678 22.5445532,10.6716121 L22.540989,10.6544482 L22.5386811,10.6441605 C21.9409716,7.93080713 20.1980483,5.52459872 17.7275611,4.09669013 C15.3940263,2.74793814 12.6309353,2.40096889 9.92784665,3.03880654 L9.6,3.121 L9.587,3.124 L9.59919596,3.12156223 C9.17076832,3.26539767 8.98531159,3.71933451 9.18428772,4.07637327 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#radialGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 4.96,
    y: 11.44,
    width: 15.36,
    height: 2.72
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlp);
export default __webpack_public_path__ + "static/media/alp.b6569f087ccf88e5c9fe5c7849614cbb.svg";
export { ForwardRef as ReactComponent };